import React from "react";
import "./MigrationBanner.scss";
import { REISIFT_URL } from "@containers/NicheFiles/utils/legacySubscription";
import MigrationImg from "@assets/files/images/reisift/migration.png";

const MigrationBanner: React.FC = () => {
  return (
    <div className="migration-banner">
      <div className="migration-banner__content">
        <div className="migration-banner__text-section">
          <h2 className="migration-banner__heading">We’re migrating the DataFlik platform to DataSift. </h2>
          <p className="migration-banner__description">
            Soon, this application will no longer be available.
            <br />
            To continue using the service, please create or reopen your account in the new app{" "}
            <a
              href="https://www.loom.com/share/816dd05ec6944a0a95f3ee61e768c89d"
              target="_blank"
              rel="noopener noreferrer"
              className="migration-banner__link"
            >
              Watch &quot;Welcome to DataSift&ldquo; Tutorial
            </a>
          </p>
          <button
            className="migration-banner__button"
            onClick={() => {
              window.open(REISIFT_URL, "_blank");
            }}
          >
            Go to DataSift
          </button>
        </div>
        <div className="migration-banner__image-section">
          <img src={MigrationImg} alt="DataSift" />
        </div>
      </div>
    </div>
  );
};

export default MigrationBanner;
